import G6 from '@antv/g6';
// lineDash array
const lineDash = [4, 2, 1, 2];

function renderRunEdge() {
    G6.registerEdge(
        'can-running',
        {
            setState(name, value, item) {
                const shape = item.get('keyShape');
                if (name === 'running') {
                    if (value) {
                        let index = 0;
                        shape.animate(
                            () => {
                                index++;
                                if (index > 9) {
                                    index = 0;
                                }
                                const res = {
                                    lineDash,
                                    lineDashOffset: -index,
                                };
                                // return the params for this frame
                                return res;
                            },
                            {
                                repeat: true,
                                duration: 3000,
                            },
                        );
                    } else {
                        shape.stopAnimate();
                        shape.attr('lineDash', null);
                    }
                }
            },
        },
        'cubic-horizontal',
    );
}
export { renderRunEdge }